import ApiCall from "../../../../Apicall/ApiCall";

// The deal's change-of-ownership stage on the Klargo backend (ContractOwnershipAppService). The
// server owns the stage; nothing here decides anything on its own. There is no Transportstyrelsen
// integration behind it — the only state is the seller's own statement that they have reported
// the transfer, recorded as one row in the deal's log.
const BASE = "/ContractOwnership";

const unwrap = (response) => response?.data?.result ?? response?.data;

/** The server's error code (UserFriendlyException.Message), e.g. "ownershipSellerOnly". */
export function ownershipErrorCode(error) {
  return error?.response?.data?.error?.message ?? null;
}

export const ownershipApi = {
  getState: async (contractId) =>
    unwrap(await ApiCall({ url: `${BASE}/GetState`, method: "GET", params: { Id: contractId } })),

  /** Seller only: "I have reported the change of ownership." The stage's one progression event. */
  reportTransfer: async (contractId) =>
    unwrap(await ApiCall({ url: `${BASE}/ReportTransfer`, method: "POST", data: { id: contractId } })),
};
